// PostgreSQL data type limits
export const POSTGRES_INT_MAX = 2147483647;
export const POSTGRES_INT_MIN = -2147483648;